angular.module('unica_notification_template.notification_template_services')

.factory('NotificationTemplateDeleteService', function ($http, getBaseApiURL) {

	var notificationTemplateDeleteService = {};

	notificationTemplateDeleteService.delete = function (notificationTemplateId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/notification-template/delete/' + notificationTemplateId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return notificationTemplateDeleteService;
});